import { isIE } from 'shared/helpers'

export const scrollToRef = (ref) => {
  if (isIE) {
    const currentScrollTop = window.scrollY || document.body.scrollTop || 0
    const scrollElement = ref.offsetParent
    scrollElement?.scrollBy({
      top: ref.offsetTop - currentScrollTop,
      behavior: 'smooth'
    })
  } else {
    ref.scrollIntoView({ behavior: 'smooth' })
  }
}
